import React, { Component } from "react";

import PropTypes from "prop-types";

import { withStyles, Grid } from "@material-ui/core";
import Carousel from 'react-bootstrap/Carousel'

import styles from "./styles";
import './styles.css';
import pokemon1 from "../../../assets/images/pokemon1.jpg";
import asiathumb from "../../../assets/images/asiathumb.png";
import guidethumb from "../../../assets/images/guidethumb.png";
import generatorthumb from "../../../assets/images/generatorthumb.png";

class Home extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      index: 0,
      direction: null
    }
  }

  handleResize = (e) => {
    this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.addEventListener("resize", this.handleResize);
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Grid container style={{ height: this.state.windowHeight / 1.5, backgroundColor: 'black' }}>
          <Grid item xs={12} md={5}>
            <Carousel style={{ height: "100%", width: "100%", display: 'block' }} arrows={false} controls={false} indicators={false}>
              <Carousel.Item>
                <div
                  className="d-block"
                  style={{
                    minWidth: "200%",
                    height: (this.state.windowWidth < 960) ? this.state.windowHeight / 3 : this.state.windowHeight / 1.5,
                    backgroundImage: `url(${pokemon1})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "bottom center",
                    filter: `blur(5px)`,
                  }}
                />
                <Carousel.Caption style={{ top: 0 }}>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                    <a href="/pokemon">
                      <h1 style={{ width: "200px", textAlign: 'left', color: 'white', textShadow: `1px 1px #000` }}><b>Pokémon</b></h1>
                    </a>
                  </div>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </Grid>
          <Grid item xs={12} md={7} style={{ position: 'relative', display: 'inline-flex' }}>
            <div
              className="d-block"
              style={{
                minWidth: "100%",
                height: (this.state.windowWidth < 960) ? this.state.windowHeight / 3 : this.state.windowHeight / 1.5,
                minHeight: "100%",
                backgroundImage: `url(${pokemon1})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                // filter: `blur(5px)`,
                // -webkit-filter: blur(8px);
              }}
            />
          </Grid>
        </Grid>

        <Grid container style={{ height: "100%", paddingTop: 32 }}>
          <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column', paddingLeft: 64, paddingRight: 64 }}>
            <h2 style={{ textAlign: "left", marginBottom: 32 }}><b>VGC 2023 Teamsheet Generator</b></h2>
            <Grid container spacing={6}>
              <Grid xs={12} md={6} lg={4} item style={{ height: this.state.windowHeight / 2.5, marginBottom: 16 }}>
                <a href="/teamsheet">
                  <div class="reportbox" style={{
                    height: "60%", backgroundImage: `url(${generatorthumb})`, display: 'flex', backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", backdropFilter: `blur(5px)`,
                  }}>
                  </div>
                  <h2 style={{ textAlign: 'left', alignSelf: 'end', marginTop: 16 }}>VGC 2023 Teamsheet Generator<br />and Translator</h2>
                </a>
              </Grid>
            </Grid>
            <h2 style={{ textAlign: "left", marginBottom: 32 }}><b>Team Reports</b></h2>
            <Grid container spacing={6}>
              <Grid xs={12} md={6} lg={4} item style={{ height: this.state.windowHeight / 2.5, marginBottom: 16 }}>
                <a href="/pokemon-asia-cup-2021">
                  <div class="reportbox" style={{
                    height: "60%", backgroundImage: `url(${asiathumb})`, display: 'flex', backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", backdropFilter: `blur(5px)`,
                  }}>
                  </div>
                  <h2 style={{ textAlign: 'left', alignSelf: 'end', marginTop: 16 }}>Pokémon Asia Cup 2021:<br />Lilligant Shenanigans</h2>
                </a>
              </Grid>
            </Grid>
            <h2 style={{ textAlign: "left", marginBottom: 32 }}><b>Ga-Olé Guides</b></h2>
            <Grid container spacing={6}>
              <Grid xs={12} md={6} lg={4} item style={{ height: this.state.windowHeight / 2.5, marginBottom: 16 }}>
                <a href={process.env.PUBLIC_URL + 'GaOleAuthenticityGuide.pdf'} target="_blank" rel="noreferrer">
                  <div class="reportbox" style={{
                    height: "60%", backgroundImage: `url(${guidethumb})`, display: 'flex', backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", backdropFilter: `blur(5px)`,
                  }}>
                  </div>
                  <h2 style={{ textAlign: 'left', alignSelf: 'end', marginTop: 16 }}>Pokémon Ga-Olé Disk<br />Authenticity Guide</h2>
                </a>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(Home);
